import NinjaTable from 'components/tables/NinjaTable';
import React from 'react';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import { DotDigitFormatter, JustValueFormatter } from 'components/tables/NinjaTable/formatters';
import ValueFormatter from 'components/table-formatters/values/ValueFormatter';
import { OwerflowNameFormatter } from 'components/tables/NinjaTable/formatters';
import { NameDefinition } from 'components/NameDefinition';
import { useWidget } from 'components/Widget/useWidget';

const ProductSalesTable = ({ height, index }) => {
  const { filters } = useWidget();
  const { dates } = useWidgetDate('product_sales' + index);

  const columns = [
    {
      key: 'product_title',
      name: 'Product Title',
      resizable: true,
      sortable: true,
      renderCell: ({ row }) => {
        const imgSrc = row?.image_url;
        return (
          <OwerflowNameFormatter
            title={row.product_title}
            img={imgSrc}
            key={row?.product_id}
            className='!bg-background-light rounded-md text-xs !font-semibold !h-9'
          />
        );
      },
      renderSummaryCell: () => 'Totals',
    },
    {
      key: 'gross_income',
      type: 'income',
      name: <NameDefinition name='Gross Income' definition='Total of all product prices' />,
      renderCell: JustValueFormatter,
      renderSummaryCell: JustValueFormatter,
      sortable: true,
      resizable: true,
    },
    {
      key: 'net_profit',
      type: 'profit',
      name: (
        <NameDefinition
          name='Net Profit'
          definition='Net profit: Total sales minus the total cost of goods sold.'
        />
      ),
      renderCell: DotDigitFormatter,
      renderSummaryCell: DotDigitFormatter,
      sortable: true,
      minWidth: 120,
      currency: true,
    },
    {
      key: 'orders_count',
      name: (
        <NameDefinition
          name='Orders Count'
          definition='Number of orders placed for a specific product'
        />
      ),
      sortable: true,
      renderCell: ValueFormatter,
      renderSummaryCell: ValueFormatter,
    },
    {
      key: 'net_quantity',
      name: (
        <NameDefinition
          name='Net Quantity'
          definition='Net Quantity in product sales refers to the total number of units sold after accounting for returns, refunds, or cancellations.'
        />
      ),
      sortable: true,
      renderCell: ValueFormatter,
      renderSummaryCell: ValueFormatter,
    },
    {
      key: 'orders_returned',
      name: (
        <NameDefinition
          name='Orders Returned'
          definition='Total number of products that have been returned.'
        />
      ),
      sortable: true,
      renderCell: ValueFormatter,
      renderSummaryCell: ValueFormatter,
    },
    {
      key: 'quantity_returned',
      name: (
        <NameDefinition
          name='Quantity Returned'
          definition='Total number of products that were returned.'
        />
      ),
      sortable: true,
      renderCell: ValueFormatter,
      renderSummaryCell: ValueFormatter,
    },
    {
      key: 'returns_value',
      name: (
        <NameDefinition name='Returns Value' definition='Total value of the products returned' />
      ),
      sortable: true,
      renderCell: JustValueFormatter,
      renderSummaryCell: JustValueFormatter,
    },
  ];

  return (
    <NinjaTable
      columns={columns}
      dataProvider='integrationProductSales'
      queryParams={{ ...dates, ...filters }}
      cardProps={{ disable: true }}
      maxHeight={height}
      footerProps={{ readOnlyPagination: true }}
      defaultSortColumns={{ columnKey: 'gross_income', direction: 'DESC' }}
      tableProps={{ template: 'widget' }}
    />
  );
};

export default ProductSalesTable;
